// extracted by mini-css-extract-plugin
export var infoItem = "_re-2";
export var title = "_re-0";
export var value = "_re-1";